import React from 'react'

import NewLayout from 'components/Layout/LayoutV1'
import useViewport from 'hooks/useViewport'

import SerpContentRich from './components/SerpContentRich'
import SerpDefault from './components/SerpDefault'
const Serp = props => {
  const { crxEnabled } = props.serpData
  const { up } = useViewport()
  return crxEnabled ? (
    <NewLayout isSticky={up('md')}>
      <SerpContentRich {...props} />
    </NewLayout>
  ) : (
    <NewLayout>
      <SerpDefault {...props} />
    </NewLayout>
  )
}

export default Serp
